import React from "react";
import { GraduationCap, MessageCircle, CheckCircle2 } from "lucide-react";
import Layout from "../components/Layout";
import useSeo from "../hooks/useSeo";

const WHATSAPP = "shillongteermorning4758@gmail.com";

const tips = [
  "Always study the Previous Result archive before choosing a target — patterns in House and Ending digits tell a story.",
  "Focus on mastering the House (tens digit) and Ending (units digit) rather than chasing exact Direct numbers.",
  "Track Hot and Cold numbers using the Analytics page as a historical reference, not as a guarantee.",
  "Keep your own logbook of daily numbers to recognise repeating visual patterns faster.",
  "Never chase a missed target aggressively — re-evaluate the chart each day and set a strict personal limit.",
];

const TeerAacharya = () => {
  useSeo(
    "Teer Aacharya | Morning Sunday Teer Tips & Guidance",
    "Teer Aacharya — traditional and analytical Morning Sunday Teer tips and guidance for Shillong Morning Teer followers."
  );
  return (
  <Layout title="Teer Aacharya">
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="flex items-center gap-2 mb-2">
        <GraduationCap className="w-6 h-6 text-[#7b61a8]" />
        <h1 className="text-xl font-bold text-[#1f2a37]">
          Teer Aacharya — Morning Teer Guidance
        </h1>
      </div>
      <p className="text-[#374151] leading-relaxed mb-6">
        Learn how experienced followers approach the Shillong <b>Morning Teer</b>{" "}
        session. These are traditional, analytical tips based on studying past
        results — treat them as culture and entertainment, never as a
        guaranteed prediction.
      </p>

      <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 mb-6">
        <h2 className="font-bold text-[#1f2a37] mb-4">
          Teer Aacharya's Daily Tips
        </h2>
        <ul className="space-y-3">
          {tips.map((t, i) => (
            <li key={i} className="flex gap-3 text-sm text-[#374151]">
              <CheckCircle2 className="w-5 h-5 text-[#7b61a8] shrink-0 mt-0.5" />
              <span>{t}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-[#7b61a80f] border border-[#7b61a833] rounded-xl p-5 flex items-center gap-4 max-w-md">
        <span className="w-11 h-11 rounded-lg bg-[#7b61a822] flex items-center justify-center shrink-0">
          <MessageCircle className="w-5 h-5 text-[#7b61a8]" />
        </span>
        <div>
          <p className="text-xs text-gray-500">Contact Teer Aacharya</p>
          <a
            href={`mailto:${WHATSAPP}`}
            className="font-medium text-[#2f5d84] hover:underline break-all"
          >
            {WHATSAPP}
          </a>
        </div>
      </div>

      <p className="text-xs text-gray-500 italic mt-6">
        Disclaimer: All guidance is for educational and entertainment purposes.
        The result depends on a physical arrow count and cannot be reliably
        predicted. Please play responsibly.
      </p>
    </div>
  </Layout>
  );
};

export default TeerAacharya;
